@if (!isMobile) {
  @if(!openDesktopDialog) {
    <button
    mat-icon-button
    [matMenuTriggerFor]="menu"
    id="{{ idLabel }}-menu-more-options-btn"
    class="btn-icon-slim"
    [attr.aria-label]="'ARIA_LABEL.ADDRESS.MENU.MORE_OPTIONS' | translate : { for: menuAriaLabel }"
    [attr.aria-description]="'ARIA_DESC.ADDRESS.MENU.MORE_OPTIONS' | translate"
    [disabled]="disabled"
    >
    <mat-icon>more_vert</mat-icon>
  </button>
  } @else {
    <button
    mat-icon-button
    (click)="openDesktopDialogFn()"
    id="{{ idLabel }}-menu-more-options-btn"
    class="btn-icon-slim"
    [attr.aria-label]="'ARIA_LABEL.ADDRESS.MENU.MORE_OPTIONS' | translate : { for: menuAriaLabel }"
    [attr.aria-description]="'ARIA_DESC.ADDRESS.MENU.MORE_OPTIONS' | translate"
    [disabled]="disabled"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
  }
} @else {
<button
  mat-icon-button
  (click)="openMobileMenu()"
  id="{{ idLabel }}-menu-more-options-btn"
  class="btn-icon-slim"
  [attr.aria-label]="'ARIA_LABEL.ADDRESS.MENU.MORE_OPTIONS' | translate : { for: menuAriaLabel }"
  [attr.aria-description]="'ARIA_DESC.ADDRESS.MENU.MORE_OPTIONS' | translate"
  [disabled]="disabled"
>
  <mat-icon>more_vert</mat-icon>
</button>
}

<mat-menu #menu="matMenu">
  @if(menuTitleKey) {
    <div class="mb-25 ml-12" >
      <h2 >{{ menuTitleKey | translate }}</h2>
    </div>
  }
  @for (option of options; track option; let isLast = $last) {
  <div>
    <button
      mat-menu-item
      (click)="openDesktopMenu(option)"
      [disabled]="
        (option.disabled | typeOf) === 'function' ? option && $any(option?.disabled)(item, itemIndex) : option.disabled
      "
      id="menu-context-{{ itemIndex }}-{{ option.label | lowercase }}-btn"
      [ngClass]="{ 'reverse-icon': reverseButtonIcon }"
      [attr.aria-label]="option.label | translate"
      [style.color]="option.color || undefined"
    >
    <mat-icon aria-hidden="true" [style.color]="option.color || undefined">
      {{ option.icon }}
    </mat-icon>
    {{ option.label | translate }}
    </button>
  </div>
  }
</mat-menu>
